import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import ControlledSelect from '@/components/common/form/ControlledSelect';
import translate from '@/lib/intl/translate';

export default function AssigneeSelect({
  className,
  disabled,
  id,
  name,
  options,
}) {
  const { control } = useFormContext();

  return (
    <FormControl size="small" className={className} disabled={disabled}>
      <InputLabel
        className="whitespace-nowrap"
        id={`assignee-select-label-${id}`}
      >
        {translate('CONSTITUENT_ASSIGNEE')}
      </InputLabel>
      <ControlledSelect
        className="w-full"
        control={control}
        id={`assignee-select-${id}`}
        label={translate('TASKS_ASSIGNEE')}
        labelId={`assignee-select-label-${id}`}
        multiple
        name={name}
      >
        {options.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {`@${label}`}
          </MenuItem>
        ))}
      </ControlledSelect>
    </FormControl>
  );
}

AssigneeSelect.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ),
};

AssigneeSelect.defaultProps = {
  className: '',
  disabled: false,
  id: null,
  name: 'developers',
  options: [],
};
